<aside class="bg-white border-2 border-dark-gray rounded-3xl h-100-l p-8 prose">
	<slot />
</aside>
